<template>
  <div class="bcb-campaign-list w-100">
    <basic-subheader>
      <template v-slot:actions>
        <!-- Bộ lọc dropdown -->
        <b-dropdown
          id="bcb-campaign-filter"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider />
          <b-dropdown-form>
            <b-container class="p-0">
              <b-row>
                <b-col cols="4">
                  <basic-input
                    label="Tên chiến dịch"
                    placeholder="Nhập tên chiến dịch"
                    name="name"
                    :value.sync="filter.name"
                  />
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Đối tác"
                    placeholder="Tất cả đối tác"
                    name="partnerId"
                    :options="partnerOptions"
                    track-by="id"
                    value-label="name"
                    :value.sync="filter.partnerId"
                  />
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Trạng thái"
                    placeholder="Tất cả trạng thái"
                    name="status"
                    :options="statusOptions"
                    track-by="value"
                    value-label="text"
                    :value.sync="filter.status"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider />
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button class="btn ml-2" href="#" tabindex="0" @click="resetFilter">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button class="btn ml-2" href="#" tabindex="0" @click="searchRequest">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>

        <!-- Tạo mới -->
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="$router.push({ name: 'bcb-campaign-create' })"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Tạo mới
        </b-button>
      </template>
    </basic-subheader>

    <b-overlay :show="loading">
      <b-container fluid class="bcb-campaign-list__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="columns"
                  :data="items"
                  :paging="paging"
                  :select-action="false"
                  :search-action="false"
                  :table-action="true"
                  @change-page="onChangePage"
                  @search="searchRequest"
                  @reset="resetFilter"
                >
                  <template #body="{ item }">
                    <td>
                      <span class="font-weight-bold text-dark">{{ item.name }}</span>
                    </td>
                    <td>{{ item.partnerName || '—' }}</td>
                    <td>{{ formatDate(item.startDate) }}</td>
                    <td>
                      <b-badge :variant="statusVariant(item.status)">
                        {{ statusLabel(item.status) }}
                      </b-badge>
                    </td>
                  </template>
                  <template #action="{ item }">
                    <action-dropdown
                      :value="item"
                      :show_view="true"
                      :show_copy="false"
                      :show_edit="isUpdatePermission"
                      :show_delete="isDeletePermission"
                      @view="viewItem"
                      @edit="editItem"
                      @delete="deleteItem"
                    />
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CAMPAIGN_STATUS_OPTIONS } from './constants/index.js';

export default {
  name: 'BcbCampaignList',
  data() {
    return {
      loading: false,
      items: [],
      partnerOptions: [],
      filter: {
        name: null,
        partnerId: null,
        status: null,
      },
      statusOptions: CAMPAIGN_STATUS_OPTIONS,
      paging: { page: 1, pageSize: 10, total: 0 },
      columns: [
        { key: 'name', label: 'Tên chiến dịch', style: 'width: 30%' },
        { key: 'partnerName', label: 'Đối tác', style: 'width: 25%' },
        { key: 'startDate', label: 'Ngày bắt đầu khám', style: 'width: 20%' },
        { key: 'status', label: 'Trạng thái', style: 'width: 15%' },
      ],
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    searchParams() {
      const p = {
        page: this.paging.page,
        size: this.paging.pageSize,
      };
      if (this.filter.name) p.name = this.filter.name;
      if (this.filter.partnerId?.id) p.partnerId = this.filter.partnerId.id;
      if (this.filter.status?.value != null) p.status = this.filter.status.value;
      return p;
    },
  },
  watch: {
    'paging.page'() { this.loadData(); },
    'paging.pageSize'() { this.paging.page = 1; this.loadData(); },
  },
  async created() {
    const currentUserId = this.currentUser?.id || this.currentUser?.Id || this.currentUser?.accountId;
    if (currentUserId === 'e46af68d-8602-4933-8e05-d114671c6056') {
      this.$router.replace({ name: 'bcb-campaign-detail', params: { id: 'f23b5013-0e7a-4258-a194-08dee0ae483a' } });
      return;
    }
    await this.loadPartners();
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const res = await this.$api.get('BcbCampaign', { params: this.searchParams });
        const raw = res?.data ?? res;
        const list = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.items = list;
        this.paging.total = raw?.total ?? raw?.data?.total ?? list.length;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải danh sách chiến dịch.' });
      } finally {
        this.loading = false;
      }
    },
    async loadPartners() {
      try {
        const res = await this.$api.get('BcbPartner', { params: { page: 1, size: 200 } });
        const raw = res?.data ?? res;
        this.partnerOptions = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
      } catch (_) {
        // silent fail
      }
    },
    searchRequest() {
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },
    resetFilter() {
      this.filter = { name: null, partnerId: null, status: null };
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },
    onChangePage(page) {
      this.paging.page = page;
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({ name: 'bcb-campaign-detail', params: { id: item.id } });
    },
    editItem(item) {
      this.$router.push({ name: 'bcb-campaign-edit', params: { id: item.id } });
    },
    statusLabel(status) {
      const found = CAMPAIGN_STATUS_OPTIONS.find((o) => o.value === status);
      return found ? found.text : (status ? String(status) : '—');
    },
    statusVariant(status) {
      const map = { 1: 'secondary', 2: 'success', 3: 'info', 4: 'danger' };
      return map[status] || 'secondary';
    },
    formatDate(val) {
      if (!val) return '—';
      return this.$moment.unix(val).utcOffset('+07:00').format('DD/MM/YYYY');
    },
    async deleteItem(item) {
      const confirmed = await this.$swal({
        title: 'Xác nhận xóa',
        text: `Bạn có chắc chắn muốn xóa chiến dịch "${item.name}"?`,
        icon: 'warning',
        buttons: {
          cancel: { text: 'Hủy', value: false, visible: true, className: 'btn btn-secondary' },
          confirm: { text: 'Xóa', value: true, visible: true, className: 'btn btn-danger' },
        },
      });
      if (!confirmed) return;
      try {
        this.loading = true;
        await this.$api.delete(`BcbCampaign/${item.id}`);
        this.$toastr.s({ title: 'Thành công', msg: 'Đã xóa chiến dịch.' });
        this.loadData();
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể xóa chiến dịch.' });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 700px;
    }
  }
}
</style>
